import React from 'react';

export default function TransactionTable() {
	return (
		<div className="table-view table-responsive">
			<table id="sales-quotes-charge-table" className="table">
				<thead>
					<tr>
						<th>Transaction Date</th>
						<th>Transaction Ref</th>
						<th>Warehouse</th>
						<th>Transaction Type</th>
						<th>Product Code</th>
						<th>Product Description</th>
						<th>Value</th>
						<th>Quantity</th>
						<th>Running Total</th>
					</tr>
				</thead>
				<tbody></tbody>
			</table>
		</div>
	);
}
